import styled from 'styled-components';

export const ContainerMenu = styled.div`
  nav {
    background: #2c3e50;
    color: #fff !important;
    min-height: 100vh;
    position: fixed;
    top: 0;
    left: 0;
    width: 240px;
    z-index: 1000;
    transition: width 0.3s ease;
  }

  /* Quando o menu está colapsado */
  nav:not(.expanded) {
    width: 60px;
  }

  p {
    color: #fff !important;
  }

  #imgLogoMenu {
    text-align: center;
    img {
      margin: 0px 0px 5px 0px;
    }
  }
`;
